/**
 * Whether a showcase had translation languages the last time this browser
 * loaded it, so the Content Studio transcript tab can name itself
 * ("Transcript" vs "Transcript & Languages", PLAT-11991) from the first frame
 * instead of waiting on the follow-up translation-fields fetch. Persisted in
 * localStorage like `lastStoryLanguage`. The fetched value always wins; this
 * only stands in until it lands, and is rewritten each time it does.
 * Best-effort: degrades silently when storage is unavailable.
 */

const keyFor = (showcaseId: string) =>
  `arbor:lastShowcaseHasLanguages:${showcaseId}`;

export function recordLastShowcaseHasLanguages(
  showcaseId: string | undefined | null,
  hasLanguages: boolean,
): void {
  if (!showcaseId) return;
  try {
    localStorage.setItem(keyFor(showcaseId), hasLanguages ? '1' : '0');
  } catch {
    // localStorage unavailable / quota — the memory is best-effort.
  }
}

/** `undefined` when this browser has never loaded the showcase's languages. */
export function getLastShowcaseHasLanguages(
  showcaseId: string | undefined | null,
): boolean | undefined {
  if (!showcaseId) return undefined;
  try {
    const value = localStorage.getItem(keyFor(showcaseId));
    return value == null ? undefined : value === '1';
  } catch {
    return undefined;
  }
}
